import customConfirmationLoResponse from "../../../../src/content/laos-response-page/customConfirmation.js";
import { LandingPageResponse } from '@bgea-js/form-templates';
import "../../../../src/content/laos-response-page/laos-response.scss";
import * as React from 'react';
export default {
  customConfirmationLoResponse,
  LandingPageResponse,
  React
};